export default __webpack_public_path__ + "static/media/apptentive.f8a5a550.svg";